import React from 'react'
import { Link} from 'gatsby'
import Badge from 'react-bootstrap/Badge'
import './SubjectBadge.css'

const SubjectBadge = ({ subject }) => {
    if(!subject) return null;
    if(subject.subject.type === "broken_type") return null;
    if(!subject.subject.document) return null;
    if(!subject.subject.document.data) return null;
    return (      
        <Badge variant="dark"  className="mb-2 mr-2">
            <Link className="badge-link" to={ subject.subject.url }>   
            {subject.subject.document.data.subject_name}
            </Link>
        </Badge>
    );
  };

  export default SubjectBadge;